import { getCookie, cookies } from '../common/cookies';

const autoLossScenarioMappings = {
  multi_vehicle: 'Collision with other vehicles',
  otherRearEnded: 'Another vehicle rear-ended me',
  iRearEnded: 'I rear ended another vehicle',
  otherChangedLanes: 'Another vehicle changed lanes into me',
  iChangedLanes: 'I changed lanes into another vehicle',
  otherTurnedLeft: 'Another vehicle turned left in front of me',
  iTurnedLeft: 'I turned left in front of another vehicle',
  otherBacked: 'Another vehicle backed into me',
  iBacked: 'I backed into another vehicle',
  iStruckParked: 'I struck another parked vehicle',
  otherStruckParked: 'My vehicle was struck while parked',
  other: 'Other',

  single_vehicle: 'Collision with something else',
  collisionWithAnimal: 'Collision with animal',
  collisionWithPedestrian: 'Collision with pedestrian',
  collisionWithCyclist: 'Collision with cyclist',
  collisionWithObjectGround: 'Collision with object/the ground',

  tree:'Tree',
  pole:'Pole',
  building:'Building',
  curb:'Curb',
  pothole:'Pothole',

  weather_events: 'Weather event',
  flooding: 'Flood',
  wind: 'Wind',
  hail: 'Hail',
  fire: 'Fire',
  lightning: 'Lightning',

  crime: 'Crime against vehicle',
  theft: 'Theft',
  attemptedTheft: 'Attempted theft',
  arsonFire: 'Arson (fire)',
  vandalism: 'Vandalism',

  random: 'Random event',
  flyingFallingObjects: 'Flying or falling object',
  explosion: 'Explosion',

  injury_only: 'Injury only',
  occupantThirdPartyVehicle: 'Occupant of another vehicle',
  injuredPedestrianOrCyclist: 'Injured as a pedestrian or cyclist',
};

const propLossScenarioMappings = {
  fire: 'Damage due to fire',
  water: 'Damage due to water',
  windHail: 'Damage due to wind or hail',
  theftMissing: 'Theft or missing item',
  other: 'Something else',
};

const autoLossScenarioMappingsFR = {
  multi_vehicle: 'Collision avec un ou plusieurs véhicules',
  otherRearEnded: 'Un autre véhicule m’a frappé par l’arrière',
  iRearEnded: 'J’ai frappé un autre véhicule par l’arrière',
  otherChangedLanes: 'AUn autre véhicule a changé de voie et m’a frappé',
  iChangedLanes: 'J’ai changé de voie et j’ai frappé un autre véhicule',
  otherTurnedLeft: 'Un autre véhicule a tourné à gauche devant moi',
  iTurnedLeft: 'J’ai tourné à gauche devant un autre véhicule',
  otherBacked: 'Un autre véhicule a reculé et m’a frappé',
  iBacked: 'J’ai reculé et frappé un autre véhicule',
  iStruckParked: 'J’ai frappé un véhicule stationné',
  otherStruckParked: 'Mon véhicule stationné a été frappé',
  other: 'Autre',

  single_vehicle: 'Collision avec autre chose',
  collisionWithAnimal: 'Collision avec un animal',
  collisionWithPedestrian: 'Collision avec un piéton',
  collisionWithCyclist: 'Collision avec un cycliste',
  collisionWithObjectGround: 'Collision avec un objet/le sol',

  tree:'Arbre',
  pole:'Poteau',
  building:'Bâtiment',
  curb:'Bordure de trottoir',
  pothole:'Nid-de-poule',

  weather_events: 'Événement météorologique',
  flooding: 'Inondation',
  wind: 'Vent',
  hail: 'Grêle',
  fire: 'Feu',
  lightning: 'Foudre',

  crime: 'Crime contre mon véhicule',
  theft: 'Vol',
  attemptedTheft: 'Tentative de vol',
  arsonFire: 'Incendie criminel',
  vandalism: 'Vandalisme',

  random: 'Autre événement',
  flyingFallingObjects: 'Objet volant ou chute d’objet',
  explosion: 'Explosion',

  injury_only: 'Blessures seulement',
  occupantThirdPartyVehicle: 'Je suis le passager d’un autre véhicule',
  injuredPedestrianOrCyclist: 'Je suis un piéton ou cycliste blessé',
};

const propLossScenarioMappingsFR = {
  fire: 'Dommages causés par un feu',
  water: 'Dommages causés par l’eau',
  windHail: 'Dommages causés par le vent ou la grêle',
  theftMissing: 'Vol ou objet manquant',
  other: 'Autre',
};

export const mapLossCause = (claimLossScenarioLevel, claimType) => {
  const language = getCookie(cookies.CMSPreferredCulture)?.substring(0, 2) || 'en';
  if (claimType === 'auto') {
    if (language === 'fr') {
      return autoLossScenarioMappingsFR[claimLossScenarioLevel];
    }
    return autoLossScenarioMappings[claimLossScenarioLevel];
  }
  if (claimType === 'property') {
    if (language === 'fr') {
      return propLossScenarioMappingsFR[claimLossScenarioLevel];
    }
    return propLossScenarioMappings[claimLossScenarioLevel];
  }
};
